export const getWithdrawUserName = (item) => {
  if (!item) return '-';
  return (
    item.userName ||
    item.username ||
    item.name ||
    item.fullName ||
    item.user?.userName ||
    item.user?.username ||
    item.user?.name ||
    item.accountHolder ||
    '-'
  );
};

export const getWithdrawTxnId = (item) => {
  if (!item) return '-';
  return (
    item.txnId ||
    item.transactionId ||
    item.txn_id ||
    item.transaction_id ||
    item.id ||
    '-'
  );
};
